import { factory, snakify } from '@repo-level/core-front';

export interface SupportForm {
  email: string;
  content: string;
}

export const sendContactMessage = factory((r) => (contact: SupportForm) =>
  r<null>('post', 'send_contact_message', snakify({ contact }))
);
